import * as React from 'react';
import styled from 'styled-components';
import classnames from 'classnames';
import { LabelSlide } from '@estee/elc-accordion';
import { ContentSpacing } from '@estee/elc-base-theme';

interface ISectionProps {
  isSecondary?: boolean;
  hasNoPaddings?: boolean;
}

export const BaseSection = (
  {
    className,
    children,
    isSecondary,
    hasNoPaddings,
    ...rest
  }: React.HTMLAttributes<HTMLDivElement> & ISectionProps,
): JSX.Element => {
  const elementClassName = classnames(
    'elc-screen-section',
    'js-screen-section', {
      'elc-screen-section-nopaddings': hasNoPaddings,
      'elc-screen-section-secondary': isSecondary,
    },
    className,
  );
  return (
    <div className={elementClassName} {...rest}>
      {children || null}
    </div>
  );
};

const Section = styled(BaseSection)`
  width: 100%;
  margin-bottom: var(--space-default-container-space-between);
  box-sizing: border-box;
  padding: 
    var(--space-default-container-padding-top)
    var(--space-default-container-padding-right)
    var(--space-default-container-padding-bottom)
    var(--space-default-container-padding-left);

  @media (min-width: 960px) {
    margin-bottom: var(--space-desktop-container-space-between);
    padding: 
      var(--space-desktop-container-padding-top)
      var(--space-desktop-container-padding-right) 
      var(--space-desktop-container-padding-bottom)
      var(--space-desktop-container-padding-left);
  };

  ${({ hasNoPaddings }) => hasNoPaddings && `
      padding: 
        0 
        var(--space-default-container-padding-right)
        0
        var(--space-default-container-padding-left);
      @media (min-width: 960px) {
        padding: 0;
      }
    `
}
`;

export default Section;

export const SectionAccordionLabel = styled(LabelSlide)`
  .elc-label-slide-content {
      padding-top: ${ContentSpacing.space6};
  }
`;
